<template>
  <div class="contact-cards">
    <div class="contact-cards__title font-34 bold container uppercase">
      {{ $fn.tr("კონტაქტი") }}
    </div>
    <div class="cards-list container">
      <div class="card" v-for="(item, index) in contact" :key="index">
        <div class="title bold uppercase">{{ _.get(item, "[0].tipText") }}</div>
        <a
          :href="
            $mq == ' phone' || $mq == 'tablet' || $mq == 'xs'
              ? 'tel:' + _.get(item, '[0].tipHover')
              : 'javascript:void(0)'
          "
          class="teaser bold"
          >{{ _.get(item, "[0].tipHover") }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  computed: {
    contact() {
      const data = this.$store.state.main.indx?.widgets?.about_us_contact;
      return Object.values(data);
    }
  }
};
</script>

<style lang="scss">
.contact-cards {
  background: #f7f7f7;
  padding-top: 89px;
  padding-bottom: 144px;
  @media (max-width: 1023px) {
    padding-top: 55px;
    padding-bottom: 89px;
  }
  &__title {
    padding-bottom: 55px;
  }
  .cards-list {
    display: grid;
    grid-template-columns: repeat(3, minmax(0px, 1fr));
    grid-gap: 30px;
    @media (max-width: 1023px) {
      grid-template-columns: repeat(1, minmax(0px, 1fr));
    }
    .card {
      background: $white;
      height: 162px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 70px;
      position: relative;
      &:nth-child(2) {
        &::after {
          background: $yellow;
        }
      }
      &:nth-child(3) {
        &::after {
          background: $red;
        }
      }
      &::after {
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        left: 30px;
        top: 50%;
        transform: translate(0, -50%);
        border-radius: 50%;
        background: #40adec;
      }
      .title {
        margin-bottom: 12px;
      }
      .teaser {
        color: #4d4d4f;
        cursor: default;
        @media (max-width: 1024px) {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
